import { AutogenModelBrltlBillingFreightGroup, AutogenRowBrltlBillingFreightGroup } from "./autogen/AutogenModelBrltlBillingFreightGroup";

export class ModelBrltlBillingFreightGroup extends AutogenModelBrltlBillingFreightGroup<RowBrltlBillingFreightGroup> {
    constructor() {
        super(RowBrltlBillingFreightGroup);
    }
}

export class RowBrltlBillingFreightGroup extends AutogenRowBrltlBillingFreightGroup {
}